let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3SeOO")).then(() => parcelRequire('8VXJy'));